import * as Actions from '../actions';

const initialState = {
	cartData: null,
	loadingCartData: true,

	updatingCartItem: false
};

const cartReducer = function(state = initialState, action) {
	switch (action.type) {
		case Actions.GET_CART_DATA: {
			return {
				...state,
				loadingCartData: false,
				cartData: action.payload
			};
		}
		case Actions.SET_CART_DATA_LOADER: {
			return {
				...state,
				loadingCartData: action.payload
			};
		}

		case Actions.UPDATE_CART_ITEM: {
			return {
				...state,
				cartData: action.payload,
				updatingCartItem: 'updated'
			};
		}
		case Actions.SET_UPDATE_CART_ITEM_LOADER: {
			return {
				...state,
				updatingCartItem: action.payload
			};
		}

		default: {
			return state;
		}
	}
};
export default cartReducer;
